import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDynamicDataService } from '../efaact.dynamic-data-service';
import { IndirectRateHistoryModel } from './indirect-rate-history.model';

export const entityName = 'IndirectRateHistory';
@Injectable({ providedIn: 'root' })
export class IndirectRateHistoryDataService extends EfaactDynamicDataService<IndirectRateHistoryModel> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
    }
}
